export default class FormProgressBar {
  init() {
    this.progressBarElement = document.querySelector('.wpcf7-progress-bar');

    if (!this.progressBarElement) {
      return;
    }

    this.formFieldsets = document.querySelectorAll('.fieldset-cf7mls');

    if (!this.formFieldsets) {
      return;
    }

    // classes
    this.formFieldsetCurrent = 'cf7mls_current_fs';
    this.formFieldsetBack = 'cf7mls_back_fs';
    this.progressStepCurrent = 'wpcf7-progress-bar__step-current';
    this.progressBarTitleWrapper = 'wpcf7-progress-bar__title-wrapper';
    this.progressBarTitleWrapperCurrent =
      'wpcf7-progress-bar__title-wrapper--active';
    this.progressBarTitle = 'wpcf7-progress-bar__title';
    this.progressBarTitleCurrent = 'wpcf7-progress-bar__title--active';
    this.progressBarItem = 'wpcf7-progress-bar__progress-item';
    this.progressBarItemCurrent = 'wpcf7-progress-bar__progress-item--active';

    const options = {
      attributes: true,
    };

    this.formFieldsets.forEach((formFieldset) => {
      const observer = new MutationObserver((mutationList) => {
        mutationList.forEach((mutation) => {
          if (
            mutation.type === 'attributes' &&
            mutation.attributeName === 'class'
          ) {
            let currentClassState = mutation.target.classList;
            let currentCountState =
              mutation.target.getAttribute('data-cf7mls-order');

            if (currentClassState.contains(this.formFieldsetCurrent)) {
              const wpcf7Groups =
                mutation.target.querySelectorAll(
                  '[data-class="wpcf7cf_group"]'
                ) ?? [];
              const wpcf7GroupNotHidden =
                this.checkGroupNotHidden(wpcf7Groups) ?? 0;

              // Step Count

              document.querySelector(`.${this.progressStepCurrent}`).innerHTML =
                parseInt(currentCountState) + 1;

              // Step Title Wrapper

              const newTitleWrapper = document.querySelector(
                `.${this.progressBarTitleWrapper}[data-step-order="${currentCountState}"]`
              );

              document
                .querySelector(`.${this.progressBarTitleWrapperCurrent}`)
                .classList.remove(this.progressBarTitleWrapperCurrent);
              newTitleWrapper.classList.add(
                this.progressBarTitleWrapperCurrent
              );

              // Step Title

              newTitleWrapper
                .querySelector(`.${this.progressBarTitleCurrent}`)
                .classList.remove(this.progressBarTitleCurrent);
              newTitleWrapper
                .querySelector(
                  `.${this.progressBarTitle}[data-group-order="${wpcf7GroupNotHidden}"]`
                )
                .classList.add(this.progressBarTitleCurrent);

              // Step progress bar

              document
                .querySelector(
                  `.${this.progressBarItem}[data-step-order="${currentCountState}"]`
                )
                .classList.add(this.progressBarItemCurrent);
            } else if (currentClassState.contains(this.formFieldsetBack)) {
              document
                .querySelector(
                  `.${this.progressBarItem}[data-step-order="${currentCountState}"]`
                )
                .classList.add(this.progressBarItemCurrent);
            } else {
              document
                .querySelector(
                  `.${this.progressBarItem}[data-step-order="${currentCountState}"]`
                )
                .classList.remove(this.progressBarItemCurrent);
            }
          }
        });
      });

      observer.observe(formFieldset, options);
    });
  }

  checkGroupNotHidden(elements) {
    let hiddenGroup = Array.from(elements).findIndex(
      (element) => !element.classList.contains('wpcf7cf-hidden')
    );

    if (hiddenGroup < 0) {
      hiddenGroup = 0;
    }

    return hiddenGroup;
  }
}
